import Vuex from 'vuex';
import Vue from "vue";

Vue.use(Vuex);
export default new Vuex.Store({
                                  state: {
                                      userDetails: {name: "Guest"},
                                      apiKey: null,
                                      loggedIn: false,
                                      executing: false,
                                      cartSize: 0,
                                      selectedProgram: null,
                                      branding: null,
                                      filters: {
                                          showFilter: false,
                                          selectedCategories: [],
                                          selectedAttributes: [],
                                          miles: null,
                                          categories: [],
                                          attributes: []
                                      },
                                      pickupFilters: {
                                          proximityMode: 'miles',
                                          proximityOptions: [
                                              { val: 'miles', label: 'Miles' },
                                              { val: 'cityState', label: 'City & State' },
                                              { val: 'zip', label: 'Zip Code' }
                                          ],
                                          miles: 9999,
                                          city: null,
                                          state: null,
                                          zipCode: null,
                                          date: null,
                                          time: null,
                                          pickupLocation: null,
                                          pickupLocationOptions: [],
                                          vendor: null,
                                          dateOptions: [],
                                          timeOptions: []
                                      },
                                      orderNote: null
                                  },
                                  mutations: {
                                      // ######### Generic mutations #########
                                      SET_LOGGED_IN: (state, newValue) => {
                                          state.loggedIn = newValue;
                                      },
                                      SET_API_KEY: (state, newValue) => {
                                          state.apiKey = newValue;
                                      },
                                      SET_EXECUTING: (state, newValue) => {
                                          state.executing = newValue;
                                      },
                                      SET_USER_DETAILS: (state, newValue) => {
                                          state.userDetails = newValue;
                                          if (newValue && newValue.currentProgram) {
                                              localStorage.setItem("program", newValue.currentProgram.programId)
                                              if (newValue.currentProgram.branding)
                                                  state.branding = newValue.currentProgram.branding
                                          }
                                      },
                                      SET_SELECTED_PROGRAM: (state, newValue) => {
                                          state.selectedProgram = newValue;
                                      },
                                      SET_CURRENT_PROGRAM: (state, newValue) => {
                                          state.userDetails.currentProgram = newValue;
                                      },
                                      SET_CART_SIZE: (state, newValue) => {
                                          state.cartSize = newValue;
                                      },
                                      SET_BRANDING: (state, newValue) => {
                                          state.branding = newValue;
                                      },
                                      SET_ORDER_NOTE: (state, newValue) => {
                                          state.orderNote = newValue;
                                      },


                                      // ######### Pickup filters #########
                                      SET_PICKUP_FILTER_PROXIMITY_MODE: (state, newVal) => {
                                          state.pickupFilters.proximityMode = newVal;
                                      },
                                      SET_PICKUP_FILTER_MILES: (state, newVal) => {
                                          state.pickupFilters.miles = newVal;
                                      },
                                      SET_PICKUP_FILTER_CITY: (state, newVal) => {
                                          state.pickupFilters.city = newVal;
                                      },
                                      SET_PICKUP_FILTER_STATE: (state, newVal) => {
                                          state.pickupFilters.state = newVal;
                                      },
                                      SET_PICKUP_FILTER_ZIP_CODE: (state, newVal) => {
                                          state.pickupFilters.zipCode = newVal;
                                      },
                                      SET_PICKUP_FILTER_LOCATION: (state, newVal) => {
                                          state.pickupFilters.pickupLocation= newVal;
                                      },
                                      SET_PICKUP_FILTER_VENDOR: (state, newVal) => {
                                        state.pickupFilters.vendor= newVal;
                                      },
                                      SET_PICKUP_FILTER_DATE: (state, newVal) => {
                                          state.pickupFilters.date = newVal;
                                      },
                                      SET_PICKUP_FILTER_TIME: (state, newVal) => {
                                          state.pickupFilters.time = newVal;
                                      },
                                      SET_PICKUP_FILTER_LOCATION_OPTIONS: (state, newVal) => {
                                          state.pickupFilters.pickupLocationOptions = newVal;
                                      },
                                      SET_PICKUP_FILTER_DATE_OPTIONS: (state, newVal) => {
                                          state.pickupFilters.dateOptions = newVal;
                                      },
                                      SET_PICKUP_FILTER_TIME_OPTIONS: (state, newVal) => {
                                          state.pickupFilters.timeOptions = newVal;
                                      },


                                      // ######### Products filters #########
                                      TOGGLE_FILTER: (state) => {
                                          state.filters.showFilter = !state.filters.showFilter;
                                      },
                                      SET_FILTER_VISIBLE: (state, newVal) => {
                                          state.filters.showFilter = newVal;
                                      },
                                      SET_FILTER_CATEGORIES: (state, newVal) => {
                                          state.filters.categories = newVal;
                                      },
                                      SET_FILTER_ATTRIBUTES: (state, newVal) => {
                                          state.filters.attributes = newVal;
                                      },
                                      SET_FILTER_SELECTED_CATEGORIES: (state, newVal) => {
                                          state.filters.selectedCategories = newVal;
                                      },
                                      SET_FILTER_SELECTED_ATTRIBUTES: (state, newVal) => {
                                          state.filters.selectedAttributes = newVal;
                                      },
                                  },
                                  getters: {
                                      apiKey: state => {
                                          return state.apiKey;
                                      },
                                      currentUser: state => {
                                          return state.userDetails
                                      }
                                  },
                                  actions: {
                                      setApiKey: ({commit, state}, newValue) => {
                                          commit('SET_API_KEY', newValue);
                                          localStorage.setItem("api_key", newValue);
                                          return state.apiKey;
                                      },
                                      setLoggedIn: ({commit, state}, newValue) => {
                                          commit('SET_LOGGED_IN', newValue);
                                          let el = document.getElementById("app-wrapper")
                                          if (el) el.classList.remove("rr-bg")
                                          return state.loggedIn;
                                      },
                                      setUserDetails: ({commit, state}, newValue) => {
                                          commit('SET_USER_DETAILS', newValue);
                                          return state.userDetails;
                                      },
                                      setSelectedProgram: ({commit, state}, newValue) => {
                                          commit('SET_SELECTED_PROGRAM', newValue);
                                          return state.selectedProgram;
                                      },
                                      setCurrentProgram: ({commit, state}, newValue) => {
                                          commit('SET_CURRENT_PROGRAM', newValue);
                                          return state.userDetails.currentProgram;
                                      },
                                      setExecuting: ({commit, state}, newValue) => {
                                          commit('SET_EXECUTING', newValue);
                                          return state.executing;
                                      },
                                      logout: ({commit, state}) => {
                                          commit("SET_LOGGED_IN", false);
                                          commit("SET_USER_DETAILS", null);
                                          commit("SET_API_KEY", null);
                                          localStorage.removeItem("api_key");
                                          return state.userDetails
                                      },
                                      setCartSize: ({commit, state}, newValue) => {
                                          commit('SET_CART_SIZE', newValue);
                                          return state.cartSize;
                                      },
                                      setBranding: ({commit, state}, newValue) => {
                                          commit('SET_BRANDING', newValue);
                                          return state.branding;
                                      },
                                      setDefaultBranding: ({commit, state}) => {
                                          let branding = {logoUrl: "https://cdn.aggrega8.com/fl-logo-black.png",
                                              landscapeSplashUrl: "https://cdn.aggrega8.com/A2GDesktopBackground.jpg",
                                              portraitSplashUrl: "https://cdn.aggrega8.com/A2GMobile.jpg"
                                          }
                                          commit('SET_BRANDING', branding);
                                          return state.branding;
                                      },
                                      toggleFilter: ({commit, state}) => {
                                          commit("TOGGLE_FILTER");
                                          return state.filters.showFilter
                                      }
                                  }
                              }
);